import { EnvironmentProviders, Injectable, Provider } from "@angular/core"
import { ProductsRoutesProvider } from "./lib/routes/product.routes";

@Injectable({ providedIn: 'root' })
export class TasksConfigService {
	constructor() {}
}

export const provideProducts = (): Array<Provider | EnvironmentProviders> => {
	return [
        { provide: ProductsRoutesProvider.getToken(), useClass: ProductsRoutesProvider, multi: true }
    ];
}